import { Input } from "@chakra-ui/react";

const TextInputStep = ({ value, onChange, placeholder, isError}) => {
  return (
      <Input
          placeholder={placeholder || "Type here..."}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          size={{ base: "md", md: "xl" }}
          mb={{ base: isError ? 1 : 6, md: isError ? 3 : 14 }}
      />
  );
};

export default TextInputStep;